<template>
  <Header />
  <SideBar />
  <main id="main-content" class="ml-64 p-8">
    <div id="page-header" class="mb-8">
      <div class="flex items-center justify-between">
        <div>
          <h2 class="text-2xl font-bold text-green-800">Billing Managment</h2>
          <p class="mt-2 text-gray-600 text-sm">All requests on your organization ledger are found here</p>
        </div>
      </div>
    </div>
    <!-- API Keys Table -->
    <div id="users-table" class="bg-white rounded-lg shadow-sm border border-gray-200">
      <div v-if="billingStore.loading" class="flex justify-center items-center h-48">
        <div class="animate-spin rounded-full h-10 w-10 border-b-2 border-green-600"></div>
      </div>
      <div class="overflow-x-auto" v-if="!billingStore.loading">
        <table class="w-full">
          <thead class="bg-gray-50">
            <tr>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase
                tracking-wider">Request ID</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase
                tracking-wider">Amount</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase
                tracking-wider">Created</th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
            <tr id="user" v-for="ledger in  billingStore.lederResults" :key="ledger.id">
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                <div>
                  <div class="text-sm font-medium text-gray-900">{{ ledger.requestId }}</div>
                  <div class="text-sm text-gray-500" v-if="ledger.serviceName?.String.length > 0">{{
                    ledger.serviceName?.String }}</div>

                  <div class="text-sm text-gray-500" v-if="ledger.serviceName?.String.length <= 0">{{
                    ledger.txnType.toUpperCase() }}</div>
                </div>
              </td>
              <td class=" px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                UGX {{ billingStore.getFormattedAmount(ledger.amount) }}
              </td>
              <td class=" px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {{ formatDate(ledger.createdAt) }}
              </td>
            </tr>
          </tbody>
        </table>
        <div class="px-6 py-4 border-t border-gray-200">
          <div class="flex items-center justify-between">
            <div class="text-sm text-gray-700">
              Showing <span class="font-medium">{{ billingStore.pagination.currentPage }}</span> of <span
                class="font-medium">{{ billingStore.pagination.totalPages }}</span> results
            </div>
            <div class="flex items-center space-x-2" v-if="billingStore.pagination.nextPage > 0">
              <button class="px-3 py-1 border border-gray-300 rounded text-sm text-gray-500 hover:bg-gray-50"
                disabled>Previous</button>
              <button class="px-3 py-1 bg-blue-600 text-white rounded text-sm">{{
                billingStore.pagination.nextPage }}</button>
              <button
                class="px-3 py-1 border border-gray-300 rounded text-sm text-gray-700 hover:bg-gray-50">Next</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useBillingStore } from '@/store/billing';
import { formatCharge } from '@/utils/chargeHandler';

import LottieAnimation from 'lottie-vuejs/src/LottieAnimation.vue';
import Header from '../components/header.vue';
import SideBar from '../components/sidebar.vue';

const billingStore = useBillingStore();
const showModal = ref<boolean>(false);

onMounted(() => {
  const purpose = localStorage.getItem('purpose');

  if (purpose === 'public') {
    billingStore.fetchLedger(1);
  } else if (purpose === 'local') {
    billingStore.fetchAdminLedger(1);
  }
});

function formatDate(input: string) {
  const date = new Date(input);
  const formatted = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
  }).format(date);
  return formatted;
}

</script>
